import { CountriesEnum } from '../shared/enum/countries.enum';

import type { IntakeMarket } from './establishment-intake';

/**
 * What one person usually spends, in local currency, and the age for any alcohol.
 * Countries that serve beer earlier (Germany, Austria, Switzerland, Belgium) still
 * use 18 here: the form option means the whole night, including spirits.
 * Malaysia is 21. Thailand, Iceland and Japan are 20. South Korea is 19.
 * Everywhere else in the roadmap is 18.
 */
const euro: IntakeMarket = { currency: 'EUR', bands: [12, 30, 70], drinkingAge: 18 };

export const INTAKE_MARKETS: Record<CountriesEnum, IntakeMarket> = {
    [CountriesEnum.ITALY]: euro,
    [CountriesEnum.SWITZERLAND]: { currency: 'CHF', bands: [18, 40, 80], drinkingAge: 18 },
    [CountriesEnum.LATVIA]: euro,
    [CountriesEnum.ESTONIA]: euro,
    [CountriesEnum.LITVA]: euro,
    [CountriesEnum.CZECH]: { currency: 'CZK', bands: [200, 500, 1100], drinkingAge: 18 },
    [CountriesEnum.POLAND]: { currency: 'PLN', bands: [40, 100, 200], drinkingAge: 18 },
    [CountriesEnum.HUNGARY]: { currency: 'HUF', bands: [3000, 8000, 18000], drinkingAge: 18 },
    [CountriesEnum.AUSTRIA]: euro,
    [CountriesEnum.SLOVAKIA]: euro,
    [CountriesEnum.CROATIA]: euro,
    [CountriesEnum.PORTUGAL]: euro,
    [CountriesEnum.SPAIN]: euro,
    [CountriesEnum.GREECE]: euro,
    [CountriesEnum.RUSSIA]: { currency: 'RUB', bands: [600, 1800, 4000], drinkingAge: 18 },
    [CountriesEnum.GERMANY]: euro,
    [CountriesEnum.FRANCE]: euro,
    [CountriesEnum.UNITED_KINGDOM]: { currency: 'GBP', bands: [10, 25, 55], drinkingAge: 18 },
    [CountriesEnum.NETHERLANDS]: euro,
    [CountriesEnum.IRELAND]: euro,
    [CountriesEnum.DENMARK]: { currency: 'DKK', bands: [90, 220, 450], drinkingAge: 18 },
    [CountriesEnum.SWEDEN]: { currency: 'SEK', bands: [120, 280, 600], drinkingAge: 18 },
    [CountriesEnum.BELGIUM]: euro,
    [CountriesEnum.ICELAND]: { currency: 'ISK', bands: [2500, 6000, 14000], drinkingAge: 20 },
    [CountriesEnum.TURKEY]: { currency: 'TRY', bands: [300, 800, 1800], drinkingAge: 18 },
    [CountriesEnum.THAILAND]: { currency: 'THB', bands: [150, 400, 900], drinkingAge: 20 },
    [CountriesEnum.CHINA]: { currency: 'CNY', bands: [40, 120, 300], drinkingAge: 18 },
    [CountriesEnum.MALAYSIA]: { currency: 'MYR', bands: [15, 45, 100], drinkingAge: 21 },
    [CountriesEnum.VIETNAM]: { currency: 'VND', bands: [80000, 200000, 500000], drinkingAge: 18 },
    [CountriesEnum.HONG_KONG]: { currency: 'HKD', bands: [80, 200, 500], drinkingAge: 18 },
    [CountriesEnum.MACAU]: { currency: 'MOP', bands: [80, 200, 500], drinkingAge: 18 },
    [CountriesEnum.BELARUS]: { currency: 'BYN', bands: [20, 50, 120], drinkingAge: 18 },
    [CountriesEnum.GEORGIA]: { currency: 'GEL', bands: [15, 40, 90], drinkingAge: 18 },
    [CountriesEnum.JAPAN]: { currency: 'JPY', bands: [1500, 4000, 10000], drinkingAge: 20 },
    [CountriesEnum.ARMENIA]: { currency: 'AMD', bands: [4000, 10000, 25000], drinkingAge: 18 },
    [CountriesEnum.SINGAPORE]: { currency: 'SGD', bands: [15, 40, 90], drinkingAge: 18 },
    [CountriesEnum.SOUTH_KOREA]: { currency: 'KRW', bands: [15000, 40000, 100000], drinkingAge: 19 },
    [CountriesEnum.TAIWAN]: { currency: 'TWD', bands: [250, 700, 1800], drinkingAge: 18 },
};

export const intakeMarket = (country: CountriesEnum): IntakeMarket => {
    const market = INTAKE_MARKETS[country];

    if (!market) {
        throw new Error(`No intake market for ${country}`);
    }

    return market;
};
